// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ============================================================
   Re-authenticate modal — in-place, premium, theme-aware.
   ViewEncapsulation.None: stili GLOBALI (necessario perché ion-modal
   teleporta il contenuto fuori dallo scope del componente → gli stili
   _ngcontent e le variabili su :host non lo raggiungerebbero).
   Tutto è annidato sotto .reauth / ion-modal.reauth-modal-host per non
   leakare. I token stanno su .reauth (self-contained → valgono ovunque
   il contenuto venga spostato); dark = body.dark .reauth.
   ============================================================ */
/* ion-modal host: trasparente e auto-size — il card interno fornisce sfondo/ombra.
   ion-modal (non un div) fa entrare la modale nello stack di overlay Ionic → prende
   lei il focus-trap anche sopra un altro modale Ionic (fix "non si scrive nel campo"). */
ion-modal.reauth-modal-host {
  --width: min(390px, calc(100vw - 40px));
  --height: auto;
  --max-height: calc(100vh - 40px);
  --border-radius: 16px;
  --background: transparent;
  --box-shadow: none;
  --backdrop-opacity: 1; /* look controllato interamente da ::part(backdrop) */
}

/* Backdrop IDENTICO alla modale notifiche dell'app (global.scss →
   .release-notes-history-modal-wrapper): frost chiaro + saturazione, non scurimento.
   Così è coerente con lo standard modali dell'app. */
ion-modal.reauth-modal-host::part(backdrop) {
  opacity: 1;
  background: rgba(15, 23, 42, 0.3);
  backdrop-filter: blur(16px) saturate(180%);
  -webkit-backdrop-filter: blur(16px) saturate(180%);
}

/* Card: tutti i design token qui → self-contained, valgono ovunque. Light default. */
.reauth {
  --accent-rgb: 126, 194, 74;
  --accent-400: #9ad46a;
  --accent-600: #5da33a;
  --accent-glow: rgba(126, 194, 74, .55);
  --ra-r: 16px;
  --ease-out: cubic-bezier(.22, 1, .36, 1);
  --font: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, system-ui, sans-serif;
  --mono: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  --sc-ink: #0d1a33;
  --sc-dim: #5b6472;
  --panel-2: #f6f8fb;
  --field-bg: #f6f8fb;
  --field-border: rgba(13, 26, 51, .12);
  --card: #ffffff;
  --card-border: rgba(13, 26, 51, .08);
  --card-shadow: 0 50px 120px -30px rgba(13, 26, 51, .45), 0 2px 10px rgba(13, 26, 51, .08);
  --safe: #5da33a;
  --danger: #dc2626;
  position: relative;
  width: 100%;
  box-sizing: border-box;
  background: var(--card);
  border: 1px solid var(--card-border);
  border-radius: var(--ra-r);
  box-shadow: var(--card-shadow);
  padding: 26px 26px 22px;
  overflow: hidden;
  font-family: var(--font);
}

body.dark .reauth {
  --sc-ink: #eef2f8;
  --sc-dim: #8b95a7;
  --panel-2: rgba(255, 255, 255, .03);
  --field-bg: rgba(255, 255, 255, .05);
  --field-border: rgba(255, 255, 255, .14);
  --card: #0d1220;
  --card-border: rgba(255, 255, 255, .09);
  --card-shadow: 0 60px 140px -30px rgba(0, 0, 0, .9), 0 0 0 1px rgba(255, 255, 255, .05) inset;
  --safe: #9ad46a;
  --danger: #f87171;
}

.reauth * {
  box-sizing: border-box;
}

.reauth > * {
  position: relative;
}

.reauth .ra-glow {
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  width: 220px;
  height: 120px;
  background: radial-gradient(circle, rgba(var(--accent-rgb), 0.3), transparent 68%);
  filter: blur(8px);
  pointer-events: none;
}

.reauth .ra-icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  color: #fff;
  margin-bottom: 16px;
  background: linear-gradient(150deg, var(--accent-400), var(--accent-600));
  box-shadow: 0 10px 24px -8px var(--accent-glow), 0 0 0 1px rgba(255, 255, 255, 0.18) inset;
}

.reauth .ra-icon svg {
  width: 24px;
  height: 24px;
}

.reauth h3 {
  font-size: 19px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: var(--sc-ink);
  margin-bottom: 6px;
}

.reauth .ra-sub {
  font-size: 13px;
  line-height: 1.55;
  color: var(--sc-dim);
  margin-bottom: 20px;
}

.reauth .ra-field {
  margin-bottom: 14px;
}

.reauth .ra-flabel {
  display: block;
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--sc-dim);
  margin-bottom: 7px;
}

.reauth .ra-userbox {
  display: flex;
  align-items: center;
  gap: 9px;
  height: 44px;
  padding: 0 13px;
  border-radius: 11px;
  background: var(--panel-2);
  border: 1px dashed var(--field-border);
  color: var(--sc-ink);
  font-size: 13.5px;
  font-weight: 600;
}

.reauth .ra-userbox > svg {
  width: 16px;
  height: 16px;
  color: var(--sc-dim);
  flex: none;
}

.reauth .ra-userbox .u {
  font-family: var(--mono);
}

.reauth .ra-userbox .lock {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 600;
  color: var(--sc-dim);
}

.reauth .ra-userbox .lock svg {
  width: 13px;
  height: 13px;
}

.reauth .ra-inputbox {
  display: flex;
  align-items: center;
  height: 46px;
  padding: 0 6px 0 13px;
  border-radius: 11px;
  background: var(--field-bg);
  border: 1px solid var(--field-border);
  transition: border-color 0.18s, box-shadow 0.18s;
}

.reauth .ra-inputbox:focus-within {
  border-color: var(--accent-600);
  box-shadow: 0 0 0 4px rgba(var(--accent-rgb), 0.14);
}

.reauth .ra-inputbox.invalid {
  border-color: rgba(239, 68, 68, 0.55);
}

.reauth .ra-inputbox .key {
  width: 16px;
  height: 16px;
  color: var(--sc-dim);
  flex: none;
}

.reauth .ra-inputbox input {
  flex: 1;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  font-family: var(--font);
  font-size: 14px;
  color: var(--sc-ink);
  padding: 0 10px;
}

.reauth .ra-inputbox input::placeholder {
  color: var(--sc-dim);
  opacity: 0.7;
}

.reauth .ra-eye {
  border: 0;
  background: transparent;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  color: var(--sc-dim);
  display: grid;
  place-items: center;
}

.reauth .ra-eye:hover {
  color: var(--sc-ink);
}

.reauth .ra-eye svg {
  width: 17px;
  height: 17px;
}

.reauth .ra-error {
  color: var(--danger);
  font-size: 12px;
  font-weight: 500;
  margin-top: 7px;
}

.reauth .ra-primary {
  width: 100%;
  height: 48px;
  border: 0;
  border-radius: 12px;
  cursor: pointer;
  margin-top: 6px;
  font-family: var(--font);
  font-size: 14.5px;
  font-weight: 650;
  letter-spacing: 0.01em;
  color: #08210a;
  background: linear-gradient(150deg, var(--accent-400), var(--accent-600));
  box-shadow: 0 14px 28px -10px var(--accent-glow);
  transition: transform 0.15s var(--ease-out), filter 0.15s;
}

.reauth .ra-primary:hover:not(:disabled) {
  transform: translateY(-1px);
  filter: brightness(1.03);
}

.reauth .ra-primary:active:not(:disabled) {
  transform: translateY(0);
}

.reauth .ra-primary:disabled {
  opacity: 0.6;
  cursor: default;
}

.reauth .ra-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
}

.reauth .ra-safe {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11.5px;
  font-weight: 600;
  color: var(--safe);
}

.reauth .ra-safe svg {
  width: 14px;
  height: 14px;
}

.reauth .ra-signout {
  font-size: 12.5px;
  font-weight: 600;
  color: var(--sc-dim);
  text-decoration: none;
  border-bottom: 1px solid transparent;
  cursor: pointer;
}

.reauth .ra-signout:hover {
  color: var(--sc-ink);
  border-bottom-color: var(--sc-dim);
}

.reauth .ra-signout:focus-visible {
  outline: 2px solid var(--accent-600);
  outline-offset: 3px;
  border-radius: 3px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/reauth-modal/reauth-modal.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;;;;;;iEAAA;AAUA;;yFAAA;AAGA;EACE,uCAAA;EACA,cAAA;EACA,gCAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA,EAAA,qDAAA;AACF;;AACA;;qDAAA;AAGA;EACE,UAAA;EACA,iCAAA;EACA,0CAAA;EACA,kDAAA;AAEF;;AACA,qFAAA;AACA;EACE,0BAAA;EACA,qBAAA;EACA,qBAAA;EACA,sCAAA;EACA,YAAA;EACA,wCAAA;EACA,6FAAA;EACA,gEAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qCAAA;EACA,eAAA;EACA,oCAAA;EACA,yFAAA;EACA,eAAA;EACA,iBAAA;EAEA,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,uBAAA;EACA,oCAAA;EACA,0BAAA;EACA,8BAAA;EACA,uBAAA;EACA,gBAAA;EACA,wBAAA;AACF;;AACA;EACE,iBAAA;EACA,iBAAA;EACA,mCAAA;EACA,oCAAA;EACA,wCAAA;EACA,eAAA;EACA,uCAAA;EACA,6FAAA;EACA,eAAA;EACA,iBAAA;AAEF;;AACA;EAAY,sBAAA;AAGZ;;AAFA;EAAc,kBAAA;AAMd;;AAJA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,aAAA;EACA,kFAAA;EACA,iBAAA;EACA,oBAAA;AAOF;;AAJA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,yEAAA;EACA,0FAAA;AAOF;;AALA;EAAuB,WAAA;EAAa,YAAA;AAUpC;;AARA;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;AAWF;;AATA;EACE,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;AAYF;;AATA;EAAoB,mBAAA;AAapB;;AAZA;EACE,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,oBAAA;EACA,kBAAA;AAeF;;AAZA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,0BAAA;EACA,sCAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;AAeF;;AAbA;EAA4B,WAAA;EAAa,YAAA;EAAc,oBAAA;EAAsB,UAAA;AAoB7E;;AAnBA;EAAyB,wBAAA;AAuBzB;;AAtBA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AAyBF;;AAvBA;EAAgC,WAAA;EAAa,YAAA;AA4B7C;;AA1BA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,qCAAA;EACA,gDAAA;AA6BF;;AA3BA;EACE,+BAAA;EACA,mDAAA;AA8BF;;AA5BA;EAA+B,qCAAA;AAgC/B;;AA/BA;EAA4B,WAAA;EAAa,YAAA;EAAc,oBAAA;EAAsB,UAAA;AAsC7E;;AArCA;EACE,OAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,wBAAA;EACA,eAAA;EACA,oBAAA;EACA,eAAA;AAwCF;;AAtCA;EAA0C,oBAAA;EAAsB,YAAA;AA2ChE;;AA1CA;EACE,SAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;AA6CF;;AA3CA;EAAwB,oBAAA;AA+CxB;;AA9CA;EAAsB,WAAA;EAAa,YAAA;AAmDnC;;AAjDA;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAoDF;;AAjDA;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,yEAAA;EACA,gDAAA;EACA,yDAAA;AAoDF;;AAlDA;EAA2C,2BAAA;EAA6B,wBAAA;AAuDxE;;AAtDA;EAA4C,wBAAA;AA0D5C;;AAzDA;EAA+B,YAAA;EAAa,eAAA;AA8D5C;;AA5DA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AA+DF;;AA7DA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AAgEF;;AA9DA;EAAuB,WAAA;EAAa,YAAA;AAmEpC;;AAlEA;EACE,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,oCAAA;EACA,eAAA;AAqEF;;AAnEA;EAA4B,oBAAA;EAAsB,kCAAA;AAwElD;;AAvEA;EAAoC,oCAAA;EAAsC,mBAAA;EAAqB,kBAAA;AA6E/F","sourcesContent":["/* ============================================================\n   Re-authenticate modal — in-place, premium, theme-aware.\n   ViewEncapsulation.None: stili GLOBALI (necessario perché ion-modal\n   teleporta il contenuto fuori dallo scope del componente → gli stili\n   _ngcontent e le variabili su :host non lo raggiungerebbero).\n   Tutto è annidato sotto .reauth / ion-modal.reauth-modal-host per non\n   leakare. I token stanno su .reauth (self-contained → valgono ovunque\n   il contenuto venga spostato); dark = body.dark .reauth.\n   ============================================================ */\n\n/* ion-modal host: trasparente e auto-size — il card interno fornisce sfondo/ombra.\n   ion-modal (non un div) fa entrare la modale nello stack di overlay Ionic → prende\n   lei il focus-trap anche sopra un altro modale Ionic (fix \"non si scrive nel campo\"). */\nion-modal.reauth-modal-host {\n  --width: min(390px, calc(100vw - 40px));\n  --height: auto;\n  --max-height: calc(100vh - 40px);\n  --border-radius: 16px;\n  --background: transparent;\n  --box-shadow: none;\n  --backdrop-opacity: 1; /* look controllato interamente da ::part(backdrop) */\n}\n/* Backdrop IDENTICO alla modale notifiche dell'app (global.scss →\n   .release-notes-history-modal-wrapper): frost chiaro + saturazione, non scurimento.\n   Così è coerente con lo standard modali dell'app. */\nion-modal.reauth-modal-host::part(backdrop) {\n  opacity: 1;\n  background: rgba(15, 23, 42, 0.3);\n  backdrop-filter: blur(16px) saturate(180%);\n  -webkit-backdrop-filter: blur(16px) saturate(180%);\n}\n\n/* Card: tutti i design token qui → self-contained, valgono ovunque. Light default. */\n.reauth {\n  --accent-rgb: 126, 194, 74;\n  --accent-400: #9ad46a;\n  --accent-600: #5da33a;\n  --accent-glow: rgba(126, 194, 74, .55);\n  --ra-r: 16px;\n  --ease-out: cubic-bezier(.22, 1, .36, 1);\n  --font: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, system-ui, sans-serif;\n  --mono: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  --sc-ink: #0d1a33;\n  --sc-dim: #5b6472;\n  --panel-2: #f6f8fb;\n  --field-bg: #f6f8fb;\n  --field-border: rgba(13, 26, 51, .12);\n  --card: #ffffff;\n  --card-border: rgba(13, 26, 51, .08);\n  --card-shadow: 0 50px 120px -30px rgba(13, 26, 51, .45), 0 2px 10px rgba(13, 26, 51, .08);\n  --safe: #5da33a;\n  --danger: #dc2626;\n\n  position: relative;\n  width: 100%;\n  box-sizing: border-box;\n  background: var(--card);\n  border: 1px solid var(--card-border);\n  border-radius: var(--ra-r);\n  box-shadow: var(--card-shadow);\n  padding: 26px 26px 22px;\n  overflow: hidden;\n  font-family: var(--font);\n}\nbody.dark .reauth {\n  --sc-ink: #eef2f8;\n  --sc-dim: #8b95a7;\n  --panel-2: rgba(255, 255, 255, .03);\n  --field-bg: rgba(255, 255, 255, .05);\n  --field-border: rgba(255, 255, 255, .14);\n  --card: #0d1220;\n  --card-border: rgba(255, 255, 255, .09);\n  --card-shadow: 0 60px 140px -30px rgba(0, 0, 0, .9), 0 0 0 1px rgba(255, 255, 255, .05) inset;\n  --safe: #9ad46a;\n  --danger: #f87171;\n}\n\n.reauth * { box-sizing: border-box; }\n.reauth > * { position: relative; }\n\n.reauth .ra-glow {\n  position: absolute;\n  top: -40px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 220px;\n  height: 120px;\n  background: radial-gradient(circle, rgba(var(--accent-rgb), .30), transparent 68%);\n  filter: blur(8px);\n  pointer-events: none;\n}\n\n.reauth .ra-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 14px;\n  display: grid;\n  place-items: center;\n  color: #fff;\n  margin-bottom: 16px;\n  background: linear-gradient(150deg, var(--accent-400), var(--accent-600));\n  box-shadow: 0 10px 24px -8px var(--accent-glow), 0 0 0 1px rgba(255, 255, 255, .18) inset;\n}\n.reauth .ra-icon svg { width: 24px; height: 24px; }\n\n.reauth h3 {\n  font-size: 19px;\n  font-weight: 700;\n  letter-spacing: -.01em;\n  color: var(--sc-ink);\n  margin-bottom: 6px;\n}\n.reauth .ra-sub {\n  font-size: 13px;\n  line-height: 1.55;\n  color: var(--sc-dim);\n  margin-bottom: 20px;\n}\n\n.reauth .ra-field { margin-bottom: 14px; }\n.reauth .ra-flabel {\n  display: block;\n  font-size: 11.5px;\n  font-weight: 600;\n  letter-spacing: .02em;\n  text-transform: uppercase;\n  color: var(--sc-dim);\n  margin-bottom: 7px;\n}\n\n.reauth .ra-userbox {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  height: 44px;\n  padding: 0 13px;\n  border-radius: 11px;\n  background: var(--panel-2);\n  border: 1px dashed var(--field-border);\n  color: var(--sc-ink);\n  font-size: 13.5px;\n  font-weight: 600;\n}\n.reauth .ra-userbox > svg { width: 16px; height: 16px; color: var(--sc-dim); flex: none; }\n.reauth .ra-userbox .u { font-family: var(--mono); }\n.reauth .ra-userbox .lock {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--sc-dim);\n}\n.reauth .ra-userbox .lock svg { width: 13px; height: 13px; }\n\n.reauth .ra-inputbox {\n  display: flex;\n  align-items: center;\n  height: 46px;\n  padding: 0 6px 0 13px;\n  border-radius: 11px;\n  background: var(--field-bg);\n  border: 1px solid var(--field-border);\n  transition: border-color .18s, box-shadow .18s;\n}\n.reauth .ra-inputbox:focus-within {\n  border-color: var(--accent-600);\n  box-shadow: 0 0 0 4px rgba(var(--accent-rgb), .14);\n}\n.reauth .ra-inputbox.invalid { border-color: rgba(239, 68, 68, .55); }\n.reauth .ra-inputbox .key { width: 16px; height: 16px; color: var(--sc-dim); flex: none; }\n.reauth .ra-inputbox input {\n  flex: 1;\n  min-width: 0;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  font-family: var(--font);\n  font-size: 14px;\n  color: var(--sc-ink);\n  padding: 0 10px;\n}\n.reauth .ra-inputbox input::placeholder { color: var(--sc-dim); opacity: .7; }\n.reauth .ra-eye {\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 8px;\n  color: var(--sc-dim);\n  display: grid;\n  place-items: center;\n}\n.reauth .ra-eye:hover { color: var(--sc-ink); }\n.reauth .ra-eye svg { width: 17px; height: 17px; }\n\n.reauth .ra-error {\n  color: var(--danger);\n  font-size: 12px;\n  font-weight: 500;\n  margin-top: 7px;\n}\n\n.reauth .ra-primary {\n  width: 100%;\n  height: 48px;\n  border: 0;\n  border-radius: 12px;\n  cursor: pointer;\n  margin-top: 6px;\n  font-family: var(--font);\n  font-size: 14.5px;\n  font-weight: 650;\n  letter-spacing: .01em;\n  color: #08210a;\n  background: linear-gradient(150deg, var(--accent-400), var(--accent-600));\n  box-shadow: 0 14px 28px -10px var(--accent-glow);\n  transition: transform .15s var(--ease-out), filter .15s;\n}\n.reauth .ra-primary:hover:not(:disabled) { transform: translateY(-1px); filter: brightness(1.03); }\n.reauth .ra-primary:active:not(:disabled) { transform: translateY(0); }\n.reauth .ra-primary:disabled { opacity: .6; cursor: default; }\n\n.reauth .ra-foot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 16px;\n}\n.reauth .ra-safe {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11.5px;\n  font-weight: 600;\n  color: var(--safe);\n}\n.reauth .ra-safe svg { width: 14px; height: 14px; }\n.reauth .ra-signout {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--sc-dim);\n  text-decoration: none;\n  border-bottom: 1px solid transparent;\n  cursor: pointer;\n}\n.reauth .ra-signout:hover { color: var(--sc-ink); border-bottom-color: var(--sc-dim); }\n.reauth .ra-signout:focus-visible { outline: 2px solid var(--accent-600); outline-offset: 3px; border-radius: 3px; }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
